module.exports = __webpack_public_path__ + "static/media/facebook_icon.ca38b2a1.svg";